import React from 'react';

const Blog = () => {
    return (
        <div>
            <section class="design" id="design">
                <div class="container">
                

                    <div class="design-content">

                        <div class="design-item">
                            <div class="design-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i> 22</span>
                                <span >Product</span>
                            </div>
                            <div class="design-title">
                                <a href="#">make an awesome art portfolio for college or university</a>
                            </div>
                        </div>


                        <div class="design-item">
                            <div class="design-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i> 22</span>
                                <span >Product</span>
                            </div>
                            <div class="design-title">
                                <a href="#">make an awesome art portfolio for college or university</a>
                            </div>
                        </div>


                        <div class="design-item">
                            <div class="design-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i> 22</span>
                                <span >Product</span>
                            </div>
                            <div class="design-title">
                                <a href="#">make an awesome art portfolio for college or university</a>
                            </div>
                        </div>

                        <div class="design-item">
                            <div class="design-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i> 22</span>
                                <span >Product</span>
                            </div>
                            <div class="design-title">
                                <a href="#">make an awesome art portfolio for college or university</a>
                            </div>
                        </div>

                        <div class="design-item">
                            <div class="design-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i> 22</span>
                                <span >Product</span>
                            </div>
                            <div class="design-title">
                                <a href="#">make an awesome art portfolio for college or university</a>
                            </div>
                        </div>

                        <div class="design-item">
                            <div class="design-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i> 22</span>
                                <span >Product</span>
                            </div>
                            <div class="design-title">
                                <a href="#">make an awesome art portfolio for college or university</a>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <section class="blog" id="blog">
                <div class="container">
                    <div class="title">
                        <h2>Latest Blog</h2>
                        <p>recent blogs about art & design</p>
                    </div>
                    <div class="blog-content">

                        <div class="blog-item">
                            <div class="blog-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i></span>
                            </div>
                            <div class="blog-text">
                                <span>20 January, 2020</span>
                                <h2>Lorem ipsum, dolor sit amet consectetur adipisicing</h2>
                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis libero quas ipsum laudantium nihil! Quaerat.</p>
                                <a href="#">Read More</a>
                            </div>
                        </div>

                        <div class="blog-item">
                            <div class="blog-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i></span>
                            </div>
                            <div class="blog-text">
                                <span>20 January, 2020</span>
                                <h2>Lorem ipsum, dolor sit amet consectetur adipisicing</h2>
                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis libero quas ipsum laudantium nihil! Quaerat.</p>
                                <a href="#">Read More</a>
                            </div>
                        </div>

                        <div class="blog-item">
                            <div class="blog-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i></span>
                            </div>
                            <div class="blog-text">
                                <span>20 January, 2020</span>
                                <h2>Lorem ipsum, dolor sit amet consectetur adipisicing</h2>
                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis libero quas ipsum laudantium nihil! Quaerat.</p>
                                <a href="#">Read More</a>
                            </div>
                        </div>

                        <div class="blog-item">
                            <div class="blog-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i></span>
                            </div>
                            <div class="blog-text">
                                <span>20 January, 2020</span>
                                <h2>Lorem ipsum, dolor sit amet consectetur adipisicing</h2>
                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis libero quas ipsum laudantium nihil! Quaerat.</p>
                                <a href="#">Read More</a>
                            </div>
                        </div>

                        <div class="blog-item">
                            <div class="blog-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i></span>
                            </div>
                            <div class="blog-text">
                                <span>20 January, 2020</span>
                                <h2>Lorem ipsum, dolor sit amet consectetur adipisicing</h2>
                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis libero quas ipsum laudantium nihil! Quaerat.</p>
                                <a href="#">Read More</a>
                            </div>
                        </div>

                        <div class="blog-item">
                            <div class="blog-img">
                                <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                                <span><i class="far fa-heart"></i></span>
                            </div>
                            <div class="blog-text">
                                <span>20 January, 2020</span>
                                <h2>Lorem ipsum, dolor sit amet consectetur adipisicing</h2>
                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis libero quas ipsum laudantium nihil! Quaerat.</p>
                                <a href="#">Read More</a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>



            <section class="about" id="about">
                <div class="container">
                    <div class="about-content">
                        <div>
                            <img src="https://i.ibb.co/R3NVhbf/clint-patterson-d-YEu-FB8-KQJk-unsplash.jpg" className="rounded-box" />
                        </div>
                        <div class="about-text">
                            <div class="title">
                                <h2>Catherine Doe</h2>
                                <p>art & design is my passion</p>
                            </div>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Id totam voluptatem saepe eius ipsum nam provident sapiente, natus et vel eligendi laboriosam odit eos temporibus impedit veritatis ut, illo deserunt illum voluptate quis beatae quod. Necessitatibus provident dicta consectetur labore!</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam corrupti natus, eos quia recusandae voluptatem veniam modi officiis minima provident rem sint porro fuga quos tempora ea suscipit vero velit sed laudantium eaque necessitatibus maxime!</p>
                        </div>
                    </div>
                </div>
            </section>






        </div>
    );
};

export default Blog;